"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function createHashFunction(hashConstructor) {
  return function (msg) {
    var hash = hashConstructor();
    hash.update(msg);
    return Buffer.from(hash.digest());
  };
}
exports.createHashFunction = createHashFunction;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUFFQSxTQUFnQkEsa0JBQWtCLENBQ2hDQyxlQUEyQjtFQUUzQixPQUFPLGFBQUc7SUFDUixJQUFNQyxJQUFJLEdBQUdELGVBQWUsRUFBRTtJQUM5QkMsSUFBSSxDQUFDQyxNQUFNLENBQUNDLEdBQUcsQ0FBQztJQUNoQixPQUFPQyxNQUFNLENBQUNDLElBQUksQ0FBQ0osSUFBSSxDQUFDSyxNQUFNLEVBQUUsQ0FBQztFQUNuQyxDQUFDO0FBQ0g7QUFSQUMiLCJuYW1lcyI6WyJjcmVhdGVIYXNoRnVuY3Rpb24iLCJoYXNoQ29uc3RydWN0b3IiLCJoYXNoIiwidXBkYXRlIiwibXNnIiwiQnVmZmVyIiwiZnJvbSIsImRpZ2VzdCIsImV4cG9ydHMiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL2hhc2gtdXRpbHMudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=